import {
  GET_ASYNC_JOBS,
  GET_ASYNC_JOBS_COUNT,
  SET_ASYNC_JOBS_SEARCH_FILTERS,
  SET_ASYNC_JOBS_CURRENT_PAGE,
  DOWNLOAD_ASYNC_JOB_FILE,
  CLEAR_DOWNLOADED_ASYNC_FILE,
  SET_ASYNC_JOBS_ITEMS_PER_PAGE,
  SET_NO_ENTRIES_MESSAGE_ASYNC_JOBS,
} from "../../types";
import { createAction } from "redux-actions";
import createAsyncActions from "../../../../utilities/createAsyncActions";
import { path } from "ramda";

export const {
  getAsyncJobs,
  getAsyncJobsPending,
  getAsyncJobsFulfilled,
  getAsyncJobsRejected,
} = createAsyncActions(GET_ASYNC_JOBS, "getAsyncJobs");

export const {
  getAsyncJobsCount,
  getAsyncJobsCountPending,
  getAsyncJobsCountFulfilled,
  getAsyncJobsCountRejected,
} = createAsyncActions(GET_ASYNC_JOBS_COUNT, "getAsyncJobsCount");

export const {
  downloadAsyncJobFile,
  downloadAsyncJobFilePending,
  downloadAsyncJobFileFulfilled,
  downloadAsyncJobFileRejected,
} = createAsyncActions(DOWNLOAD_ASYNC_JOB_FILE, "downloadAsyncJobFile");

export const setAsyncJobsSearchFilters = createAction(
  SET_ASYNC_JOBS_SEARCH_FILTERS
);
export const setAsyncJobsCurrentPage = createAction(
  SET_ASYNC_JOBS_CURRENT_PAGE
);
export const clearDownloadedAsyncFile = createAction(
  CLEAR_DOWNLOADED_ASYNC_FILE
);
export const setAsyncJobsItemsPerPage = createAction(
  SET_ASYNC_JOBS_ITEMS_PER_PAGE
);

export const selectAsyncJobsFilters = path(["getAsyncJobs", "filters"]);

export const selectAsyncJobsPageInfo = path(["getAsyncJobs", "pageInfo"]);

export const setNoEntriesMessage = createAction(
  SET_NO_ENTRIES_MESSAGE_ASYNC_JOBS
);



// WEBPACK FOOTER //
// ./src/features/organization/actions/getActions/getAsyncJobsActions.js